import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
var schema = defineObject('textAlignment', {
    alignment: {
        title: 'Alignment',
        type: 'string',
        description: 'Defaults to left',
        options: {
            list: [
                'left',
                'center',
                'right'
            ]
        }
    }
}, []);
var validator = z.object({
    _type: z.literal('link'),
    alignment: z.enum([
        'left',
        'center',
        'right'
    ]).optional()
});
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=textAlignment.js.map